import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { REEL_REASON_MAX } from './reelReview';
import { reelRejectMessages } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelRejectNotesFieldProps {
  notes: string;
  onChange: (notes: string) => void;
  /** The length of the joined reason (chips and notes), which the counter shows. */
  reasonLength: number;
}

/** The notes of the reject sheet (design e1). The counter counts the joined reason, 500 at most. */
const ReelRejectNotesFieldComponent: React.FC<ReelRejectNotesFieldProps> = ({ notes, onChange, reasonLength }) => {
  const intl = useIntl();
  const isTooLong = reasonLength > REEL_REASON_MAX;

  return (
    <div className={styles.field}>
      <div className={styles.countRow}>
        <label className={styles.label} htmlFor="reel-reject-notes">
          {intl.formatMessage(reelRejectMessages.notes)}
        </label>
        <span className={styles.secHint}>{intl.formatMessage(reelRejectMessages.optional)}</span>
      </div>
      <textarea
        id="reel-reject-notes"
        className={clsx(styles.textarea, isTooLong && styles.textareaBad)}
        value={notes}
        onChange={(event) => onChange(event.target.value)}
      />
      <div className={styles.countRow}>
        {isTooLong && (
          <span className={styles.bad}>{intl.formatMessage(reelRejectMessages.tooLong, { max: REEL_REASON_MAX })}</span>
        )}
        <span className={clsx(styles.count, isTooLong && styles.bad)}>
          {intl.formatMessage(reelRejectMessages.count, { count: reasonLength, max: REEL_REASON_MAX })}
        </span>
      </div>
    </div>
  );
};

export const ReelRejectNotesField = TypedMemo(ReelRejectNotesFieldComponent);
